define('views/components/reseller_manager/reseller_manager',['require','backbone','text!templates/components/reseller_manager/reseller_manager.html'],function(require){

    var Backbone = require('backbone');

    var temp = require("text!templates/components/reseller_manager/reseller_manager.html");
    return Backbone.Marionette.ItemView.extend({
        tagName: 'tr',
        template: _.template(temp),
        className: 'reseller-manager-item'
    });
});
